<template>
  <el-dialog
    :model-value="visible"
    title="Suggest a Payment Method"
    width="500px"
    @close="close"
  >
    <LoadingBlock :loading="loading" />
    <el-form
      v-if="!loading"
      ref="formObj"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <el-form-item label="Suggestion" prop="suggestion" required>
        <el-input
          v-model="formData.suggestion"
          placeholder="Type the name of the payment method you'd like us to add"
        />
      </el-form-item>
      <el-form-item label="Comment (optional)">
        <el-input
          v-model="formData.comment"
          prop="comment"
          type="textarea"
          placeholder="Comment"
          rows="3"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="close">Cancel</el-button>
      <el-button type="primary" :disabled="loading" @click="onSubmit">
        Submit
      </el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { ref, defineComponent } from 'vue'
import { safeSubmitProcessing } from '@/utils/helpers'
import { ElMessage } from 'element-plus'
import LoadingBlock from '@/components/LoadingBlock.vue'
import { useReplenishmentMethodsStore } from '@/store/modules/replenishmentMethods'

export default defineComponent({
  name: 'SuggestionForm',
  components: { LoadingBlock },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const formObj = ref()
    const loading = ref(false)
    const replenishmentMethodsStore = useReplenishmentMethodsStore()

    const formData = ref({
      suggestion: '',
      comment: ''
    })

    const rules = {
      suggestion: {
        required: true,
        message: 'This field is required',
        trigger: 'change'
      }
    }

    const resetForm = () => {
      formData.value = {
        suggestion: '',
        comment: ''
      }
      formObj.value?.resetFields()
    }

    const close = () => {
      resetForm()
      context.emit('close')
    }

    const onSuccess = () => {
      close()
      ElMessage.success({
        message: 'Your suggestion was sent successfully',
        type: 'success',
        showClose: true,
        duration: 3000
      })
    }

    const onSubmit = async () => {
      const isValid = await formObj.value?.validate()
      if (!isValid) return

      await safeSubmitProcessing(
        loading,
        () => replenishmentMethodsStore.SuggestReplenishment(formData.value),
        () => onSuccess(),
        () => {
          ElMessage.warning({
            message: 'Something went wrong, please try again later',
            type: 'error',
            showClose: true,
            duration: 3000
          })
        }
      )
    }

    return {
      formData,
      formObj,
      rules,
      loading,
      onSubmit,
      close
    }
  }
})
</script>
